/* Heritage option lists for the basketball jersey personaliser.
 * Keys match each product's custom.front_text_options metafield.
 * HOW TO EDIT: add/remove a quoted name inside the right group. Keep macrons
 * and traditional spellings exact — search folds accents automatically, so
 * customers can type "ngati" and still find "Ngāti". Never uppercase these.
 * Sources: Māori iwi — Te Kāhui Māngai. Aboriginal — AIATSIS-map-derived
 * group names + contemporary community spellings (free-text entry covers
 * anything missed). Torres Strait — island communities with traditional +
 * common names, grouped by cluster.
 */
window.LL_HERITAGE_OPTIONS = {
  "maori": {
    "groups": [
      {
        "label": "General",
        "options": [
          "Māori",
          "Aotearoa",
          "Tangata Whenua"
        ]
      },
      {
        "label": "Iwi",
        "options": [
          "Ahuriri",
          "Heretaunga Tamatea",
          "Kāti Māmoe",
          "Maungaharuru Tangitū",
          "Muaūpoko",
          "Ngā Pōtiki",
          "Ngā Rauru",
          "Ngā Wairiki Ngāti Apa",
          "Ngāi Tahu",
          "Ngāi Tāhuhu",
          "Ngāi Tai ki Tāmaki",
          "Ngāi Takoto",
          "Ngāi Tāmanuhiri",
          "Ngāi Te Ohuake",
          "Ngāi Te Rangi",
          "Ngāitai",
          "Ngāpuhi",
          "Ngāruahine",
          "Ngāti Apa ki te Rā Tō",
          "Ngāti Awa",
          "Ngāti Hako",
          "Ngāti Hāua",
          "Ngāti Hauiti",
          "Ngāti Hei",
          "Ngāti Hikairo",
          "Ngāti Hine",
          "Ngāti Hinerangi",
          "Ngāti Hineuru",
          "Ngāti Kahu",
          "Ngāti Kahu ki Whangaroa",
          "Ngāti Kahungunu",
          "Ngāti Kahungunu ki Heretaunga",
          "Ngāti Kahungunu ki Tamakinui a Rua",
          "Ngāti Kahungunu ki Tamatea",
          "Ngāti Kahungunu ki Te Wairoa",
          "Ngāti Kahungunu ki Te Whanganui-a-Orotu",
          "Ngāti Kahungunu ki Wairarapa",
          "Ngāti Kauwhata",
          "Ngāti Kea Ngāti Tuarā",
          "Ngāti Koata",
          "Ngāti Korokī Kahukura",
          "Ngāti Kuia",
          "Ngāti Kurī",
          "Ngāti Mākino",
          "Ngāti Manawa",
          "Ngāti Maniapoto",
          "Ngāti Manuhiri",
          "Ngāti Maru",
          "Ngāti Mutunga",
          "Ngāti Mutunga o Wharekauri",
          "Ngāti Pāhauwera",
          "Ngāti Pāoa",
          "Ngāti Pikiao",
          "Ngāti Porou",
          "Ngāti Porou ki Hauraki",
          "Ngāti Pūkenga",
          "Ngāti Pūkenga ki Waiau",
          "Ngāti Rāhiri Tumutumu",
          "Ngāti Rākaipaaka",
          "Ngāti Rangi",
          "Ngāti Ranginui",
          "Ngāti Rangiteaorere",
          "Ngāti Rangitihi",
          "Ngāti Rangiwewehi",
          "Ngāti Rārua",
          "Ngāti Raukawa",
          "Ngāti Raukawa ki te Tonga",
          "Ngāti Rehua",
          "Ngāti Rongomai",
          "Ngāti Ruanui",
          "Ngāti Ruapani ki Waikaremoana",
          "Ngāti Tahu Ngāti Whaoa",
          "Ngāti Tama",
          "Ngāti Tama ki Taranaki",
          "Ngāti Tama ki Te Tau Ihu",
          "Ngāti Tama ki Te Upoko o Te Ika",
          "Ngāti Tamakōpiri",
          "Ngāti Tamaoho",
          "Ngāti Tamaterā",
          "Ngāti Tara Tokanui",
          "Ngāti Tarāwhai",
          "Ngāti Te Ata",
          "Ngāti Tiipa",
          "Ngāti Toarangatira",
          "Ngāti Tukorehe",
          "Ngāti Tūmatakōkiri",
          "Ngāti Tūrangitukua",
          "Ngāti Tūwharetoa",
          "Ngāti Wai",
          "Ngāti Whakahemo",
          "Ngāti Whakaue",
          "Ngāti Whanaunga",
          "Ngāti Whare",
          "Ngāti Whātua",
          "Ngāti Whātua o Kaipara",
          "Ngāti Whātua Ōrākei",
          "Ngāti Whitikaupeka",
          "Pakakohi",
          "Rangitāne",
          "Rangitāne o Manawatū",
          "Rangitāne o Tamaki nui a Rua",
          "Rangitāne o Te Matau-a-Māui",
          "Rangitāne o Wairau",
          "Rereahu",
          "Rongomaiwahine",
          "Rongowhakaata",
          "Tamahaki",
          "Tamakana",
          "Tangāhoe",
          "Tapuika",
          "Taranaki",
          "Te Aitanga a Hauiti",
          "Te Aitanga-a-Māhaki",
          "Te Ākitai Waiohua",
          "Te Āti Haunui-a-Pāpārangi",
          "Te Atiawa",
          "Te Atiawa ki Whakarongotai",
          "Te Ātiawa o Te Waka-a-Māui",
          "Te Atiawa o Te Whanganui-a-Tara",
          "Te Aupōuri",
          "Te Hapū-oneone",
          "Te Hika o Papauma",
          "Te Kawerau ā Maki",
          "Te Korowai o Wainuiārua",
          "Te Paatu",
          "Te Patukirikiri",
          "Te Rarawa",
          "Te Roroa",
          "Te Ūpokorehe",
          "Te Uri-o-Hau",
          "Te Wairoa",
          "Te Whānau-ā-Apanui",
          "Tūhoe",
          "Tūhourangi",
          "Uenuku",
          "Uenuku-Kōpako",
          "Waikato",
          "Waitaha",
          "Whakatōhea"
        ]
      }
    ]
  },
  "torres-strait": {
    "groups": [
      {
        "label": "General",
        "options": [
          "Zenadth Kes",
          "Torres Strait",
          "Torres Strait Islander"
        ]
      },
      {
        "label": "Top Western — Guda Maluilgal",
        "options": [
          "Boigu",
          "Dauan",
          "Saibai"
        ]
      },
      {
        "label": "Western — Maluilgal",
        "options": [
          "Badu",
          "Mabuiag",
          "Moa",
          "Kubin",
          "St Pauls (Wug)"
        ]
      },
      {
        "label": "Inner — Kaiwalagal",
        "options": [
          "Waiben (Thursday Island)",
          "Ngurupai (Horn Island)",
          "Keriri (Hammond Island)",
          "Muralug (Prince of Wales)"
        ]
      },
      {
        "label": "Central — Kulkalgal",
        "options": [
          "Masig (Yorke Island)",
          "Poruma (Coconut Island)",
          "Warraber (Sue Island)",
          "Iama (Yam Island)",
          "Naghir"
        ]
      },
      {
        "label": "Eastern — Meriam",
        "options": [
          "Mer (Murray Island)",
          "Erub (Darnley Island)",
          "Ugar (Stephen Island)"
        ]
      },
      {
        "label": "Northern Peninsula Area",
        "options": [
          "Bamaga",
          "Seisia",
          "Injinoo",
          "Umagico",
          "New Mapoon"
        ]
      }
    ]
  },
  "aboriginal": {
    "groups": [
      {
        "label": "General",
        "options": [
          "First Nations",
          "Aboriginal",
          "Koori",
          "Murri",
          "Noongar",
          "Palawa",
          "Nunga",
          "Anangu",
          "Yolŋu"
        ]
      },
      {
        "label": "New South Wales & ACT",
        "options": [
          "Anaiwan",
          "Anēwan",
          "Arakwal",
          "Awabakal",
          "Badjalang",
          "Banbai",
          "Bandjigali",
          "Barababaraba,",
          "Baranbinja",
          "Barindji",
          "Barkindji",
          "Bidjigal",
          "Biripi",
          "Birpai",
          "Bundjalung",
          "Dainggati",
          "Darkinjang",
          "Darkinjung",
          "Darug",
          "Dharawal",
          "Dharug",
          "Dunghutti",
          "Eora",
          "Gadigal",
          "Gamilaraay",
          "Gandangara",
          "Githabul",
          "Gumbaynggirr",
          "Gundungurra",
          "Jeithi",
          "Jiegara",
          "Jitajita",
          "Jukambal",
          "Kalibal",
          "Kamilaroi",
          "Karenggapa",
          "Kawambarai",
          "Kayimai",
          "Kitabal",
          "Kumbainggiri",
          "Kureinji",
          "Kuringgai",
          "Kurnu",
          "Kwiambal",
          "Maljangapa",
          "Maraura",
          "Milpulo",
          "Minjungbal",
          "Morowari",
          "Muthimuthi",
          "Narinari",
          "Naualko",
          "Ngaku",
          "Ngamba",
          "Ngambri",
          "Ngarabal",
          "Ngarigo",
          "Ngiyambaa",
          "Ngiyampaa",
          "Ngunawal",
          "Ngunnawal",
          "Paakantyi",
          "Parundji",
          "Tharawal",
          "Thaua",
          "Wadikali",
          "Wailwan",
          "Walbanga",
          "Walgalu",
          "Wandandian",
          "Wangaaybuwan",
          "Wangal",
          "Wanjiwalku",
          "Waveroo",
          "Weilwan",
          "Weraerai",
          "Widjabal",
          "Wilyakali",
          "Wiradjuri",
          "Wodiwodi",
          "Wongaibon",
          "Wonnarua",
          "Worimi",
          "Yaegl",
          "Yaygirr",
          "Yuin",
          "Yuwaalaraay"
        ]
      },
      {
        "label": "Queensland",
        "options": [
          "Ankamuti",
          "Araba",
          "Atjinuri",
          "Awngthim",
          "Ayabakan",
          "Ayapathu",
          "Badjiri",
          "Baiali",
          "Bakanambia",
          "Bandjin",
          "Barada",
          "Barbaram",
          "Barna",
          "Barunggam",
          "Barungguan",
          "Batjala",
          "Bidia",
          "Bidjara",
          "Bigambul",
          "Bindal",
          "Biria",
          "Birri Gubba",
          "Bitjara",
          "Bugulmara",
          "Buluwai",
          "Butchulla",
          "Bwgcolman",
          "Dalla",
          "Darambal",
          "Darumbal",
          "Djabugandji",
          "Djabugay",
          "Djagaraga",
          "Djakunda",
          "Djankun",
          "Djirbalngan",
          "Djiru",
          "Djirubal",
          "Ewamin",
          "Gangulu",
          "Gia",
          "Giabal",
          "Gkuthaarn",
          "Goeng",
          "Goenpul",
          "Gooreng Gooreng",
          "Goreng Goreng",
          "Gubbi Gubbi",
          "Gubi Gubi",
          "Gudjal",
          "Gugu Badhun",
          "Gulngai",
          "Guugu Yimithirr",
          "Guugu-Yimidhirr",
          "Idindji",
          "Ilba",
          "Iman",
          "Indindji",
          "Iningai",
          "Irukandji",
          "Ithu",
          "Jagalingu",
          "Jagara",
          "Jagera",
          "Jalanga",
          "Jambina",
          "Jangaa",
          "Jangga",
          "Janggal",
          "Jarowair",
          "Jathaikana",
          "Jeteneru",
          "Jetimarala",
          "Jiman",
          "Jinwum",
          "Jirandali",
          "Jirjoront",
          "Jokula",
          "Juipera",
          "Jukambe",
          "Julaolinja",
          "Jungkurara",
          "Jupangati",
          "Juru",
          "Kaantju",
          "Kabalbara",
          "Kabi Kabi",
          "Kaiabara",
          "Kaiadilt",
          "Kairi",
          "Kalali",
          "Kalibamu",
          "Kalkadoon",
          "Kalkadunga",
          "Kambuwal",
          "Kandju",
          "Kangulu",
          "Kanolu",
          "Karanja",
          "Kareldi",
          "Karendala",
          "Karingbal",
          "Karuwali",
          "Kaurareg",
          "Kawadji",
          "Keinjan",
          "Keramai",
          "Koa",
          "Koamu",
          "Koenpal",
          "Koinjmal",
          "Kokangol",
          "Koknar",
          "Koko",
          "Kokobididji",
          "Kokobujundji",
          "Kokoimudji",
          "Kokojawa",
          "Kokojelandji",
          "Kokokulunggur",
          "Kokomini",
          "Kokonjekodi",
          "Kokopatun",
          "Kokopera",
          "Kokowalandja",
          "Kokowara",
          "Kongabula",
          "Kongkandji",
          "Korenggoreng",
          "Kukatj",
          "Kuku Yalanji",
          "Kuku Yulanji",
          "Kulumali",
          "Kungadutji",
          "Kunggara",
          "Kunggari",
          "Kungkalenja",
          "Kunja",
          "Kutjal",
          "Kutjala",
          "Kuuku-ya'u",
          "Kuungkari",
          "Kwantari",
          "Laia",
          "Lama Lama",
          "Lanima",
          "Lardiil",
          "Lotiga",
          "Luthigh",
          "Madjandji",
          "Maiawali",
          "Maijabi",
          "Maikudunu",
          "Maikulan",
          "Maithakari",
          "Malantji",
          "Mamu",
          "Manbarra",
          "Mandandanji",
          "Maranganji",
          "Marrago",
          "Marulta",
          "Mbewum",
          "Meriam Mir",
          "Mian",
          "Mimungkum",
          "Mingin",
          "Mitaka",
          "Mitjamba",
          "Mpalitjanh",
          "Muluridji",
          "Muragan",
          "Mutjati",
          "Mutumui",
          "Nawagi",
          "Ngandangara",
          "Ngaro",
          "Ngathokudi",
          "Ngatjan",
          "Ngaun",
          "Nggamadi",
          "Ngoborindi",
          "Ngugi",
          "Ngulungbara",
          "Ngundjan",
          "Ngurawola",
          "Nguri",
          "Njuwathai",
          "Nunukul",
          "Olkolo",
          "Ombila",
          "Otati",
          "Pakadji",
          "Pitapita",
          "Pitjara",
          "Pontunj",
          "Punthamara",
          "Quandamooka",
          "Rakkaia",
          "Ringaringa",
          "Rungarungawa",
          "Tagalag",
          "Taior",
          "Taribelang",
          "Tepiti",
          "Teppathiggi",
          "Thereila",
          "Tjapukai",
          "Tjongkandji",
          "Totj",
          "Tulua",
          "Turrbal",
          "Umbindhamu",
          "Umpila",
          "Undanbi",
          "Unjadi",
          "Uutaalnganu",
          "Waanyi",
          "Wadja",
          "Wadjabangai",
          "Wadjalang",
          "Wakabunga",
          "Wakaman",
          "Wakara",
          "Wakawaka",
          "Wakka Wakka",
          "Walangama",
          "Walmbaria",
          "Waluwara",
          "Wanamara",
          "Wangan",
          "Wanjuru",
          "Warakamai",
          "Wargamaygan",
          "Warungu",
          "Wik",
          "Wik Mungkan",
          "Wik-kalkan",
          "Wikampama",
          "Wikapatja",
          "Wikatinda",
          "Wikepa",
          "Wikianji",
          "Wikmean",
          "Wikmunkan",
          "Wiknantjara",
          "Wiknatanja",
          "Winduwinda",
          "Wiri",
          "Wongkadjera",
          "Wongkumara",
          "Woppaburra",
          "Wulgurukaba",
          "Wulili",
          "Wulpura",
          "Wuthathi",
          "Yadhaykenu",
          "Yanda",
          "Yidinji",
          "Yiman",
          "Yirrganydji",
          "Yuggera",
          "Yuguurtuu"
        ]
      },
      {
        "label": "Northern Territory",
        "options": [
          "Alura",
          "Alyawarr",
          "Alyawarre",
          "Amarak",
          "Amijangal",
          "Andakerebina",
          "Anindilyakwa",
          "Anmatyerre",
          "Arrernte",
          "Awarai",
          "Awinmul",
          "Beriguruk",
          "Bilingara",
          "Binbinga",
          "Bingongina",
          "Bininj",
          "Bukurnidja",
          "Burarra",
          "Daii",
          "Dalabon",
          "Dangbon",
          "Dangu",
          "Diakui",
          "Djalakuru",
          "Djamindjung",
          "Djangu",
          "Djerait",
          "Djerimanga",
          "Djinang",
          "Djinba",
          "Djowei",
          "Doolboong",
          "Duwal",
          "Duwala",
          "Gaari",
          "Gadjalivia",
          "Gambalang",
          "Garrwa",
          "Gunavidji",
          "Gungorogone",
          "Gurindji",
          "Indjilandji",
          "Ingura",
          "Iwaidja",
          "Jaako",
          "Jangman",
          "Janjula",
          "Jaroinga",
          "Jawoyn",
          "Jilngali",
          "Jukul",
          "Jumu",
          "Junggor",
          "Kadjerong",
          "Kaititja",
          "Kakadu",
          "Kamor",
          "Karaman",
          "Karangpurru",
          "Kaytetye",
          "Konbudj",
          "Korindji",
          "Kotandji",
          "Kunapa people",
          "Kundjeyhmi",
          "Kungarakan",
          "Kunindiri",
          "Kunwinjku",
          "Kuwema",
          "Kwarandji",
          "Larrakia",
          "Luritja",
          "Madngela",
          "Magatige",
          "Malak Malak",
          "Mangarai",
          "Maranunggu",
          "Mariamo",
          "Maridan",
          "Maridjabin",
          "Marijedi",
          "Marimanindji",
          "Maringar",
          "Marinunggo",
          "Marithiel",
          "Mariu",
          "Marra",
          "Matuntara",
          "Maung",
          "Mbukarla",
          "Menthajangal",
          "Murinbata",
          "Muringura",
          "Murngin",
          "Mutpura",
          "Nakara",
          "Nanggikorongo",
          "Nanggumiri",
          "Nango",
          "Ngalakan",
          "Ngalia",
          "Ngaliwuru",
          "Ngan'gikurunggurr",
          "Ngandi",
          "Ngardi",
          "Ngardok",
          "Ngarinman",
          "Ngewin",
          "Ngolokwangga",
          "Ngormbur",
          "Norweilemil",
          "Nunggubuju",
          "Oitbi",
          "Pintupi",
          "Pongaponga",
          "Puneitja",
          "Rembarunga",
          "Tagoman",
          "Tiwi",
          "Tjial",
          "Tjingili",
          "Tunuvivi",
          "Wadere",
          "Wagiman",
          "Wakaja",
          "Walpiri",
          "Walu",
          "Wambaia",
          "Wandarang",
          "Wandjira",
          "Wanji",
          "Waramanga",
          "Wardaman",
          "Warlpiri",
          "Warray",
          "Warumungu",
          "Watta",
          "Wilingura",
          "Wogait",
          "Wongkamala",
          "Wulwulam",
          "Wuningargk",
          "Wurango",
          "Yanyuwa"
        ]
      },
      {
        "label": "Western Australia",
        "options": [
          "Amangu",
          "Arnga",
          "Badimaya",
          "Bailgu",
          "Baiyungu",
          "Balardong",
          "Ballardong",
          "Banyjima",
          "Bardi",
          "Bibbulmun",
          "Binigura",
          "Bunuba",
          "Buruna",
          "Djaru",
          "Djiwali",
          "Djugun",
          "Duulngari",
          "Gija",
          "Ildawongga",
          "Inawongga",
          "Indjibandi",
          "Inggarda",
          "Jabirr Jabirr",
          "Jaburara",
          "Jadira",
          "Jaudjibaia",
          "Jawi",
          "Jawuru",
          "Jeidji",
          "Jinigudira",
          "Juat",
          "Kalaako",
          "Kalamaia",
          "Kambure",
          "Kaneang",
          "Karadjari",
          "Karajarri",
          "Kariara",
          "Kartudjara",
          "Keiadjara",
          "Kitja",
          "Koara",
          "Konejandi",
          "Koreng",
          "Kukatja",
          "Kurrama",
          "Kwini",
          "Madoitja",
          "Maduwongga",
          "Malgana",
          "Malgaru",
          "Malngin",
          "Malpa",
          "Mandara",
          "Mandjildjara",
          "Mandjindja",
          "Mangarla",
          "Manthi",
          "Mardudunera",
          "Martu",
          "Maya",
          "Menang",
          "Minang",
          "Miriwoong",
          "Miriwung",
          "Miwa",
          "Murunitja",
          "Nakako",
          "Nana",
          "Nanda",
          "Nangatadjara",
          "Nangatara",
          "Ngaanyatjarra",
          "Ngadadjara",
          "Ngadjunmaia",
          "Ngaiawongga",
          "Ngaluma",
          "Ngarinjin",
          "Ngarla",
          "Ngarlawongga",
          "Ngarluma",
          "Ngolibardu",
          "Ngombal",
          "Ngurlu",
          "Niabali",
          "Nimanburu",
          "Ninanu",
          "Njakinjaki",
          "Njamal",
          "Njangamarda",
          "Njikena",
          "Njulnjul",
          "Njunga",
          "Noala",
          "Nokaan",
          "Nyangumarta",
          "Nyikina",
          "Nyul Nyul",
          "Ola",
          "Ongkarango",
          "Ongkomi",
          "Paiyungu",
          "Pandjima",
          "Pibelmen",
          "Pindiini",
          "Pindjarup",
          "Pini",
          "Pinjarup",
          "Potidjara",
          "Punaba",
          "Talandiji",
          "Targari",
          "Tedei",
          "Tenma",
          "Thiin",
          "Tjalkadjara",
          "Tjeraridjal",
          "Tjupany",
          "Tjuroro",
          "Umede",
          "Wadjari",
          "Waljen",
          "Walmadjari",
          "Wanman",
          "Wardal",
          "Wardandi",
          "Wariangga",
          "Warwa",
          "Wawula",
          "Wenamba",
          "Wenambal",
          "Whadjuk",
          "Widi",
          "Wiilman",
          "Wilawila",
          "Wirdinja",
          "Wirngir",
          "Wongatha",
          "Wongi",
          "Wooptang",
          "Worora",
          "Worrorra",
          "Wudjari",
          "Wunambal",
          "Yamatji",
          "Yawuru",
          "Yindjibarndi"
        ]
      },
      {
        "label": "South Australia",
        "options": [
          "Adnyamathanha",
          "Antakirinja",
          "Arabana",
          "Barngarla",
          "Bindjali",
          "Boandik",
          "Bunganditj",
          "Danggali",
          "Dieri",
          "Erawirung",
          "Jadliaura",
          "Jandruwanta",
          "Jangkundjara",
          "Jarildekald",
          "Jeljendi",
          "Karanguru",
          "Kaurna",
          "Kokatha",
          "Kujani",
          "Meintangk",
          "Meru",
          "Mirning",
          "Narangga",
          "Narungga",
          "Nauo",
          "Ngadjuri",
          "Ngaiawang",
          "Ngalea",
          "Ngameni",
          "Nganguruku",
          "Ngaralta",
          "Ngarkat",
          "Ngarrindjeri",
          "Ngawait",
          "Ngintait",
          "Ngurunta",
          "Nukunu",
          "Pangkala",
          "Peramangk",
          "Pilatapa",
          "Pitjantjatjara",
          "Portaulun",
          "Potaruwutj",
          "Ramindjeri",
          "Tanganekald",
          "Tirari",
          "Wailpi",
          "Warki",
          "Warlmanpa",
          "Wirangu",
          "Wongkanguru",
          "Yankunytjatjara",
          "Yauraworka",
          "Yulparitja"
        ]
      },
      {
        "label": "Victoria",
        "options": [
          "Bangerang",
          "Barapa Barapa",
          "Bidawal",
          "Boon Wurrung",
          "Brabralung",
          "Braiakaulung",
          "Bratauolung",
          "Bunurong",
          "Dadi Dadi",
          "Dja Dja Wurrung",
          "Djab Wurrung",
          "Djargurd Wurrung",
          "Djilamatang",
          "Duduroa",
          "Gulidjan",
          "Gunai",
          "Gunaikurnai",
          "Gunditjmara",
          "Jaara",
          "Jaitmathang",
          "Jardwadjali",
          "Jarijari",
          "Jupagalk",
          "Katubanut",
          "Kirrae",
          "Kolakngat",
          "Krauatungalung",
          "Kurnai",
          "Kurung",
          "Kwatkwat",
          "Latji Latji",
          "Marditjali",
          "Minjambuta",
          "Ngurelban",
          "Pangerang",
          "Tatungalung",
          "Taungurung",
          "Tjapwurong",
          "Wadawurrung",
          "Wadi Wadi",
          "Warkawarka",
          "Watiwati",
          "Wemba Wemba",
          "Woiwurrung",
          "Wotjobaluk",
          "Wurundjeri",
          "Yorta Yorta"
        ]
      },
      {
        "label": "Tasmania",
        "options": [
          "Lairmairrener",
          "Lyluequonny",
          "Muwinina",
          "Nuenonne",
          "Paredarerme",
          "Peerapper",
          "Pyemmairre",
          "Tommeginne",
          "Toogee",
          "Trawlwoolway",
          "Tyerremotepanner"
        ]
      },
      {
        "label": "More nations",
        "options": [
          "Bama",
          "Culture",
          "Dhanggati",
          "Geawegal",
          "Girramay",
          "Gooniyandi",
          "Goori",
          "Gunggandji",
          "Individuals",
          "Jaru",
          "Kaanju",
          "Koorie",
          "Murrdi",
          "Murrinh-Patha",
          "Muruwari",
          "Olkola",
          "Organisations",
          "Pakana",
          "Peoples",
          "Perrakee",
          "Rembarrnga",
          "Spinifex people",
          "Walmajarri",
          "Wangkai",
          "Wangkumara",
          "Wathaurung",
          "Wergaia",
          "Wiljakali",
          "Yarra Yarra",
          "Yiwara",
          "Yolngu"
        ]
      }
    ]
  },
  "samoa": {
    "groups": [
      {
        "label": "General",
        "options": [
          "Samoa",
          "Upolu",
          "Savai'i",
          "Manono",
          "Apolima",
          "American Samoa",
          "Tutuila",
          "Manu'a"
        ]
      },
      {
        "label": "Districts",
        "options": [
          "A'ana",
          "Aiga-i-le-Tai",
          "Atua",
          "Fa'asaleleaga",
          "Gaga'emauga",
          "Gaga'ifomauga",
          "Palauli",
          "Satupa'itea",
          "Tuamasaga",
          "Va'a-o-Fonoti",
          "Vaisigano"
        ]
      },
      {
        "label": "Villages (Upolu)",
        "options": [
          "Afega",
          "Apia",
          "Faleasi'u",
          "Faleatiu",
          "Falefa",
          "Falelatai",
          "Falealili",
          "Faleula",
          "Fagali'i",
          "Fasito'o",
          "Lalomanu",
          "Lauli'i",
          "Lefaga",
          "Lepea",
          "Leulumoega",
          "Lotofaga",
          "Lufilufi",
          "Malie",
          "Matautu",
          "Moata'a",
          "Mulifanua",
          "Nofoali'i",
          "Poutasi",
          "Saleimoa",
          "Salamumu",
          "Samatau",
          "Satapuala",
          "Siumu",
          "Solosolo",
          "Toamua",
          "Tuana'i",
          "Vaiala",
          "Vailele",
          "Vailima",
          "Vaimoso",
          "Vaitele",
          "Vaiusu"
        ]
      },
      {
        "label": "Villages (Savai'i)",
        "options": [
          "A'opo",
          "Asau",
          "Faga",
          "Falealupo",
          "Gataivai",
          "Iva",
          "Lano",
          "Neiafu",
          "Puapua",
          "Safotu",
          "Safotulafai",
          "Safune",
          "Sagone",
          "Salailua",
          "Salelologa",
          "Sapapali'i",
          "Sataua",
          "Taga",
          "Tuasivi",
          "Vaisala"
        ]
      },
      {
        "label": "American Samoa",
        "options": [
          "Pago Pago",
          "Fagatogo",
          "Nu'uuli",
          "Tafuna",
          "Leone",
          "Ili'ili",
          "Vatia",
          "Aua",
          "Aunu'u",
          "Ta'ū",
          "Ofu",
          "Olosega"
        ]
      }
    ]
  },
  "tonga": {
    "groups": [
      {
        "label": "General",
        "options": [
          "Tonga",
          "Tongatapu",
          "Vava'u",
          "Ha'apai",
          "'Eua",
          "Niuafo'ou",
          "Niuatoputapu"
        ]
      },
      {
        "label": "Villages (Tongatapu)",
        "options": [
          "Nuku'alofa",
          "Kolofo'ou",
          "Kolomotu'a",
          "Ma'ufanga",
          "Havelu",
          "Haveluloto",
          "Tofoa",
          "Pea",
          "Ha'ateiho",
          "Vaini",
          "Tokomololo",
          "Nukunuku",
          "Kolovai",
          "Houma",
          "Kanokupolu",
          "Fo'ui",
          "Te'ekiu",
          "Masilamea",
          "Mu'a",
          "Lapaha",
          "Tatakamotonga",
          "Talafo'ou",
          "Navutoka",
          "Kolonga",
          "Niutoua",
          "Malapo",
          "Longoteme"
        ]
      },
      {
        "label": "Villages (Vava'u)",
        "options": [
          "Neiafu",
          "Leimatu'a",
          "Ta'anea",
          "Tu'anekivale",
          "Pangaimotu",
          "Hunga"
        ]
      },
      {
        "label": "Villages (Ha'apai)",
        "options": [
          "Pangai",
          "Lifuka",
          "Foa",
          "Ha'ano",
          "'Uiha",
          "Nomuka"
        ]
      },
      {
        "label": "'Eua",
        "options": [
          "'Ohonua"
        ]
      }
    ]
  },
  "fiji": {
    "groups": [
      {
        "label": "General",
        "options": [
          "Fiji",
          "Viti",
          "Rotuma"
        ]
      },
      {
        "label": "Provinces",
        "options": [
          "Ba",
          "Bua",
          "Cakaudrove",
          "Kadavu",
          "Lau",
          "Lomaiviti",
          "Macuata",
          "Nadroga-Navosa",
          "Naitasiri",
          "Namosi",
          "Ra",
          "Rewa",
          "Serua",
          "Tailevu"
        ]
      },
      {
        "label": "Cities & Towns",
        "options": [
          "Suva",
          "Nadi",
          "Lautoka",
          "Labasa",
          "Nausori",
          "Nasinu",
          "Sigatoka",
          "Levuka",
          "Savusavu",
          "Rakiraki",
          "Navua",
          "Tavua"
        ]
      }
    ]
  },
  "cook-islands": {
    "groups": [
      {
        "label": "General",
        "options": [
          "Cook Islands",
          "Kūki 'Āirani"
        ,
        "Kūki"
      ]
      },
      {
        "label": "Islands",
        "options": [
          "Rarotonga",
          "Aitutaki",
          "Atiu",
          "Mangaia",
          "Ma'uke",
          "Mitiaro",
          "Manihiki",
          "Rakahanga",
          "Tongareva (Penrhyn)",
          "Pukapuka",
          "Nassau",
          "Palmerston",
          "Suwarrow",
          "Takutea",
          "Manuae"
        ]
      },
      {
        "label": "Rarotonga",
        "options": [
          "Avarua",
          "Arorangi",
          "Nikao",
          "Titikaveka",
          "Matavera",
          "Ngatangiia",
          "Muri",
          "Tupapa",
          "Avatiu",
          "Puaikura",
          "Takitumu",
          "Te Au O Tonga"
        ]
      }
    ]
  },
  "philippines": {
    "groups": [
      {
        "label": "General",
        "options": [
          "Philippines",
          "Pilipinas",
          "Metro Manila",
        "ᜉᜒᜎᜒᜉᜒᜈᜐ᜔"
      ]
      },
      {
        "label": "Provinces",
        "options": [
          "Abra",
          "Agusan del Norte",
          "Agusan del Sur",
          "Aklan",
          "Albay",
          "Antique",
          "Apayao",
          "Aurora",
          "Basilan",
          "Bataan",
          "Batanes",
          "Batangas",
          "Benguet",
          "Biliran",
          "Bohol",
          "Bukidnon",
          "Bulacan",
          "Cagayan",
          "Camarines Norte",
          "Camarines Sur",
          "Camiguin",
          "Capiz",
          "Catanduanes",
          "Cavite",
          "Cebu",
          "Cotabato",
          "Davao de Oro",
          "Davao del Norte",
          "Davao del Sur",
          "Davao Occidental",
          "Davao Oriental",
          "Dinagat Islands",
          "Eastern Samar",
          "Guimaras",
          "Ifugao",
          "Ilocos Norte",
          "Ilocos Sur",
          "Iloilo",
          "Isabela",
          "Kalinga",
          "La Union",
          "Laguna",
          "Lanao del Norte",
          "Lanao del Sur",
          "Leyte",
          "Maguindanao del Norte",
          "Maguindanao del Sur",
          "Marinduque",
          "Masbate",
          "Misamis Occidental",
          "Misamis Oriental",
          "Mountain Province",
          "Negros Occidental",
          "Negros Oriental",
          "Northern Samar",
          "Nueva Ecija",
          "Nueva Vizcaya",
          "Occidental Mindoro",
          "Oriental Mindoro",
          "Palawan",
          "Pampanga",
          "Pangasinan",
          "Quezon",
          "Quirino",
          "Rizal",
          "Romblon",
          "Samar",
          "Sarangani",
          "Siquijor",
          "Sorsogon",
          "South Cotabato",
          "Southern Leyte",
          "Sultan Kudarat",
          "Sulu",
          "Surigao del Norte",
          "Surigao del Sur",
          "Tarlac",
          "Tawi-Tawi",
          "Zambales",
          "Zamboanga del Norte",
          "Zamboanga del Sur",
          "Zamboanga Sibugay"
        ]
      },
      {
        "label": "Cities",
        "options": [
          "Manila",
          "Quezon City",
          "Cebu City",
          "Davao City",
          "Iloilo City",
          "Zamboanga City",
          "Baguio",
          "Bacolod",
          "General Santos",
          "Cagayan de Oro"
        ]
      }
    ]
  },
  "australia": {
    "groups": [
      {
        "label": "General",
        "options": [
          "Australia"
        ]
      },
      {
        "label": "States & Territories",
        "options": [
          "New South Wales",
          "Victoria",
          "Queensland",
          "Western Australia",
          "South Australia",
          "Tasmania",
          "Northern Territory",
          "Australian Capital Territory"
        ]
      },
      {
        "label": "Cities",
        "options": [
          "Sydney",
          "Melbourne",
          "Brisbane",
          "Perth",
          "Adelaide",
          "Gold Coast",
          "Canberra",
          "Newcastle",
          "Hobart",
          "Darwin",
          "Townsville",
          "Cairns",
          "Wollongong",
          "Sunshine Coast",
          "Geelong"
        ]
      }
    ]
  }
};
